import { render, staticRenderFns } from "./data-sets.vue?vue&type=template&id=284c62b4&scoped=true"
import script from "./data-sets.vue?vue&type=script&lang=js"
export * from "./data-sets.vue?vue&type=script&lang=js"
import style0 from "./data-sets.vue?vue&type=style&index=0&id=284c62b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c62b4",
  null
  
)

export default component.exports